import {until} from 'lit-html/directives/until';
import {jobStatusLabels} from '../i18n-labels';
import {classMap} from 'lit-html/directives/class-map.js';

export default (ctx, html) => html`
  <span class="badge ${classMap(ctx.classes)}">
    ${until(jobStatusLabels[ctx.status])}
  </span>
`;
